import { CircleDollarSign } from "lucide-react";
import { can } from "@/features/auth/types";
import type { WidgetDef } from "../types";
import { FeesGlance, FeesView } from "./FeesWidget";
import { FeesSettings } from "./FeesSettings";

export interface FeesConfig {
  days: 7 | 14 | 30;
}

export const FEE_DAYS = [7, 14, 30] as const;

export const parseFeesConfig = (raw: unknown): FeesConfig => {
  const d = (raw as FeesConfig | null)?.days;
  return { days: (FEE_DAYS as readonly number[]).includes(d as number) ? (d as FeesConfig["days"]) : 7 };
};

export const feesWidget: WidgetDef<FeesConfig> = {
  type: "fees",
  icon: CircleDollarSign,
  title: "fees.title",
  description: "fees.description",
  sizes: ["s", "m", "l"],
  defaultSize: "m",
  defaultConfig: () => ({ days: 7 }),
  parseConfig: parseFeesConfig,
  // Faqat budjet ko'ra oladiganlar (ruxsat backend'da ham: provider)
  available: (me) => me.role === "owner" || (me.role === "branch_manager" && can(me, "budget")),
  View: FeesView,
  Glance: FeesGlance,
  Settings: FeesSettings,
};
